import { FormikProps } from "formik";
import React from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { InquiryEditValues } from "src/models/InquiryEdit.model";

type Props = {
  formikProps: FormikProps<InquiryEditValues>
};

const tabs: {
  label: string;
  path: string;
}[] = [
    {
      label: "Personal Information",
      path: "personal-information",
    },
    {
      label: "Interested Course",
      path: "interested-course",
    },
    {
      label: "Academic and Work History",
      path: "academic-and-work-history",
    },
    {
      label: "Contact Information",
      path: "contact-information",
    },
    {
      label: "Source",
      path: "source",
    },
    {
      label: "Preference",
      path: "preference",
    },
    {
      label: "Summary",
      path: "summary",
    },
  ];

const InquiryLayout = (formikProps: Props) => {
  const navigate = useNavigate();
  const location = useLocation();

  const currentPath = location.pathname.split("/")[5];

  return (

    <div className="flex h-full p-3 overflow-hidden">
      {/* Tabs */}
      <div className="w-[270px] border-r border-slate-300 p-4 pl-0 ">
        {tabs?.length &&
          tabs?.map((tab: any, index: any) => {
            return (
              <button
                key={index}
                type="button"
                onClick={() => navigate(tab.path)}
                className={`w-full p-2  border-b-[3px] text-start font-medium text-sm transition-all truncate duration-300
        ${
          currentPath === tab.path
            ? "text-white   bg-primary-dark w-full rounded-md"
            : "text-gray-700 border-white"
        }
         `}
              >
                {tab.label}
              </button>
            );
          })}
      </div>
      {/* Outlet */}
      <div className="flex-1 p-4 col-span-9 overflow-auto h-full ">
        <Outlet context={[formikProps]} />
      </div>
    </div>

  );
};

export default InquiryLayout;
